import { AuthController } from '@controllers/auth-controller';
import { ONBOARDING } from '@utils/controller-utils';
import { codeSplit } from 'bernie-core';

export class OnboardingController extends AuthController {
  public pageId = ONBOARDING;
  public path = '/partner/onboarding';
  public routeName = 'onboarding';
  public bundles = [];
  public pageTitle = 'controllers.onboarding';
  public accessRoles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "onboarding" */ '../../views/partner/onboarding'));
  public exact = false;
  public isPartnerProtected = false;
  public isPartnerView = true;
  public isAdminView = true;
}
